const accountingIntegrationTypes = {
  xero: { id: 'xero', name: 'Xero' },
  qbo: { id: 'qbo', name: 'QuickBooks' },
};

export default accountingIntegrationTypes;
